// extracted by mini-css-extract-plugin
export default {"suggestionButton":"SuggestionCard-module__suggestionButton--vCG7u","icon":"SuggestionCard-module__icon--m1MlN"};